import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "bg-[#23242A] text-white custom p-3",
  id: "content_screen"
}
const _hoisted_2 = {
  class: /*@__PURE__*/_normalizeClass('p-3 flex content-main ' )
}
const _hoisted_3 = { class: "custom-full custom-left" }
const _hoisted_4 = { class: "bg-[#2B2C32] rounded-lg px-[16px]" }
const _hoisted_5 = {
  key: 0,
  class: "flex flex-col justify-between pb-5"
}
const _hoisted_6 = { class: "w-[500px] grid grid-cols-2 gap-4" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = ["value"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = {
  key: 1,
  class: "w-[500px] grid grid-cols-2 gap-4"
}
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Nav = _resolveComponent("Nav")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Nav),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.vg_selectedLocation.id)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-[24px] py-4 font-semibold text-white" }, "Compliance Report", -1)),
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-sm mb-1" }, "Report Year", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.year) = $event)),
                      class: "bg-[#464851] border-none rounded focus:outline-none focus:border-none"
                    }, [
                      _cache[5] || (_cache[5] = _createElementVNode("option", {
                        value: "",
                        selected: "",
                        disabled: ""
                      }, " -- Select -- ", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.years, (year) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: year + 'year',
                          value: year
                        }, _toDisplayString(year), 9, _hoisted_8))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.year]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-sm mb-1" }, "Report Month", -1)),
                    _withDirectives(_createElementVNode("select", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.month) = $event)),
                      class: "bg-[#464851] border-none rounded"
                    }, [
                      _cache[7] || (_cache[7] = _createElementVNode("option", {
                        value: "",
                        selected: "",
                        disabled: ""
                      }, " -- Select -- ", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.months, (month, ind) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: ind,
                          value: ind+1
                        }, _toDisplayString(month), 9, _hoisted_10))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.month]
                    ])
                  ])
                ]),
                (_ctx.providerName!=='mbll')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.generateReport && _ctx.generateReport(...args))),
                      disabled: !_ctx.month || !_ctx.year,
                      class: _normalizeClass([(!!_ctx.month && !!_ctx.year)?'bg-theme-green text-white':'', "w-[500px] mt-6 uppercase tracking-[0.1px] font-medium h-[40px] rounded bg-[#414141] text-[#9E9E9E] px-4 py-2"])
                    }, "GENERATE Compliance Report", 10, _hoisted_11))
                  : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                      _createElementVNode("button", {
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.generateReport('CTLS'))),
                        disabled: !_ctx.month || !_ctx.year,
                        class: _normalizeClass([(!!_ctx.month && !!_ctx.year)?'bg-theme-green text-white':'', "mt-6 uppercase tracking-[0.1px] font-medium h-[40px] rounded bg-[#414141] text-[#9E9E9E] px-4 py-2"])
                      }, "GENERATE CTLS Report", 10, _hoisted_13),
                      _createElementVNode("button", {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.generateReport('LGCA'))),
                        disabled: !_ctx.month || !_ctx.year,
                        class: _normalizeClass([(!!_ctx.month && !!_ctx.year)?'bg-theme-green text-white':'', "mt-6 uppercase tracking-[0.1px] font-medium h-[40px] rounded bg-[#414141] text-[#9E9E9E] px-4 py-2"])
                      }, "GENERATE LGCA Report", 10, _hoisted_14)
                    ]))
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}